import { render, staticRenderFns } from "./M-award.vue?vue&type=template&id=72d662c4&scoped=true&"
import script from "./M-award.vue?vue&type=script&lang=js&"
export * from "./M-award.vue?vue&type=script&lang=js&"
import style0 from "./M-award.vue?vue&type=style&index=0&id=72d662c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d662c4",
  null
  
)

export default component.exports